import { TAdFoxBannerTemplate } from '@cian/adfox-component';
import { AdFoxTemplates } from '@cian/adfox-templates';
import { Base64 } from 'js-base64';
import * as React from 'react';

import { TgbNativedescGeneralContext } from '../../../../../types/AdfoxBannerContexts';
import { AdfoxDeviceTypeContext } from '../../adfoxDeviceTypeContext';
import { TgbNativedescGeneralContainer } from '../TgbNativedescGeneral';

const OWN_BUNDLE_NAMES = ['banner.transfer'];
const OWN_TYPES: TAdFoxTemplatesParams['type'][] = ['tgb_nativedesc_general'];

export type TAdFoxTemplatesParams = TgbNativedescGeneralContext;

export const OwnTemplates: React.FC<TAdFoxBannerTemplate> = props => {
  const { bundleName, bundleParams } = props;
  const deviceType = React.useContext(AdfoxDeviceTypeContext);

  if (bundleName && OWN_BUNDLE_NAMES.includes(bundleName) && bundleParams) {
    if (bundleName === 'banner.transfer' && bundleParams.htmlBase64) {
      try {
        const decodedParams = Base64.decode(bundleParams.htmlBase64);
        const parsedDecodedParams = JSON.parse(decodedParams);

        if (isParsedParamsValid(parsedDecodedParams)) {
          if (OWN_TYPES.includes(parsedDecodedParams.type)) {
            switch (parsedDecodedParams.type) {
              case 'tgb_nativedesc_general':
                return <TgbNativedescGeneralContainer context={parsedDecodedParams} />;
            }
          }
        }
      } catch (e) {
        console.error('[AdFox] Failed to decode/parse bundleParams', bundleParams, e);
      }
    }
  }

  return <AdFoxTemplates {...props} deviceType={deviceType} />;
};

function isParsedParamsValid(params: object): params is TAdFoxTemplatesParams {
  return 'type' in params;
}
